import { isNumber } from 'radash';

import { ZoneHelpers } from '@diagram/helpers/ZoneHelpers';

import {
    DiagramComponentInstance,
    DiagramConnection,
    ZoneValidationError,
    ZoneValidationErrorType,
    ZoneValidator,
} from 'models';

// Mirrors validate_fault_parameters in the simulation engine, which rejects the run on any of these.
const checkFaultNegativeValues: ZoneValidator['validator'] = ({ zones }) => {
    const errors: ZoneValidationError[] = [];

    zones.forEach((zone) => {
        const connections = zone.connections.filter(hasNegativeConnectionValue);
        const componentInstances = zone.componentInstances.filter(hasNegativePortValue);

        if (connections.length || componentInstances.length) {
            ZoneHelpers.error(
                errors,
                ZoneValidationErrorType.FAULT_NEGATIVE_VALUES,
                zone,
                componentInstances,
                connections,
            );
        }
    });

    return errors;
};

const hasNegativeConnectionValue = (connection: DiagramConnection) =>
    [connection.resistance, connection.inductance].some(hasNegativeLeaf);

const hasNegativePortValue = (componentInstance: DiagramComponentInstance) =>
    componentInstance.specifications.electrical.ports.some((port) =>
        ['capacitance', 'equivalentSeriesResistance', 'resistance'].some(
            (key) => key in port && hasNegativeLeaf(port[key as keyof typeof port]),
        ),
    );

const hasNegativeLeaf = (field: unknown) => {
    if (isNumber(field)) return field < 0;
    if (!field || typeof field !== 'object') return false;

    return ['value', 'nom', 'min', 'max'].some((key) => {
        const value = (field as Record<string, unknown>)[key];

        return isNumber(value) && value < 0;
    });
};

export { checkFaultNegativeValues };
